'use client';

import Link from 'next/link';
import {
  IconBuildingHospital,
  IconFirstAidKit,
  IconHistory,
  IconMedicineSyrup,
  IconStethoscope,
} from '@tabler/icons-react';
import { Card, Center, Text } from '@mantine/core';

export function CategoryGrid() {
  const categories = [
    {
      id: 'product',
      icon: IconMedicineSyrup,
      label: 'Produk Kesehatan',
      color: 'text-teal-600',
      bg: 'bg-teal-50',
      hoverBg: 'group-hover:bg-teal-100',
      border: 'group-hover:border-teal-200',
      href: '/produk-kesehatan?type=produk',
    },
    {
      id: 'service',
      icon: IconStethoscope,
      label: 'Layanan Kesehatan',
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      hoverBg: 'group-hover:bg-blue-100',
      border: 'group-hover:border-blue-200',
      href: '/produk-kesehatan?type=Layanan',
    },
    {
      id: 'apothecary',
      icon: IconBuildingHospital,
      label: 'Cari Outlet / Faskes',
      color: 'text-orange-600',
      bg: 'bg-orange-50',
      hoverBg: 'group-hover:bg-orange-100',
      border: 'group-hover:border-orange-200',
      href: '/produk-kesehatan?type=Toko',
    },
    // {
    //   id: 'consultation',
    //   icon: IconFirstAidKit,
    //   label: 'Telekonsultasi',
    //   color: 'text-red-600',
    //   bg: 'bg-red-50',
    //   hoverBg: 'group-hover:bg-red-100',
    //   border: 'group-hover:border-red-200',
    //   href: '/consultation',
    // },
    {
      id: 'transhistory',
      icon: IconHistory,
      label: 'Riwayat Belanja',
      color: 'text-green-600',
      bg: 'bg-green-50',
      hoverBg: 'group-hover:bg-green-100',
      border: 'group-hover:border-green-200',
      href: '/riwayat-belanja',
    },
  ];

  return (
    <div className="mt-8 mb-8 px-4">
      <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
        {categories.map((item) => (
          <Link key={item.id} href={item.href} className="group block">
            <Card
              radius="lg"
              padding="lg"
              className={`relative flex h-48 flex-col items-center justify-center border border-gray-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${item.border}`}
            >
              {/* Icon */}
              <Center
                className={`mb-4 rounded-2xl p-4 shadow-sm transition-all duration-300 ${item.bg} ${item.hoverBg} ${item.color} group-hover:scale-110`}
              >
                <item.icon size={36} stroke={1.5} />
              </Center>

              {/* Label */}
              <Text
                fw={700}
                ta="center"
                size="lg"
                className="text-gray-800 group-hover:text-gray-900"
              >
                {item.label}
              </Text>

              {/* Hover indicator */}
              <div className="absolute bottom-4 translate-y-2 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                <div className="h-1 w-8 rounded-full bg-slate-200" />
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
